export const ORGANIZER_CREATE_REQUEST = 'ORGANIZER_CREATE_REQUEST'
export const ORGANIZER_CREATE_SUCCESS = 'ORGANIZER_CREATE_SUCCESS'
export const ORGANIZER_CREATE_FAIL = 'ORGANIZER_CREATE_FAIL'
export const ORGANIZER_CREATE_RESET = 'ORGANIZER_CREATE_RESET'

export const ORGANIZER_LIST_REQUEST = 'ORGANIZER_LIST_REQUEST'
export const ORGANIZER_LIST_SUCCESS = 'ORGANIZER_LIST_SUCCESS'
export const ORGANIZER_LIST_FAIL = 'ORGANIZER_LIST_FAIL'

export const EXPIRED_ORGANIZER_LIST_REQUEST = 'EXPIRED_ORGANIZER_LIST_REQUEST'
export const EXPIRED_ORGANIZER_LIST_SUCCESS = 'EXPIRED_ORGANIZER_LIST_SUCCESS'
export const EXPIRED_ORGANIZER_LIST_FAIL = 'EXPIRED_ORGANIZER_LIST_FAIL'

export const ORGANIZER_DETAILS_REQUEST = 'ORGANIZER_DETAILS_REQUEST'
export const ORGANIZER_DETAILS_SUCCESS = 'ORGANIZER_DETAILS_SUCCESS'
export const ORGANIZER_DETAILS_FAIL = 'ORGANIZER_DETAILS_FAIL'